const namespace = 'Buss';

export const FETCH_BUSS_SUCCESS = `${namespace}/FETCH_BUSS_SUCCESS`;
export const FETCH_BUSS_ERROR = `${namespace}/FETCH_BUSS_ERROR`;
export const FETCH_BUSS = `${namespace}/FETCH_BUSS`;
export const CLEAR_BUSSES = `${namespace}/CLEAR_BUSSES`;





// WEBPACK FOOTER //
// ./src/components/Bus/constants.js